import React, { useEffect, useState } from 'react';
import { SOURCE_URL } from '../../../config';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface HomeComboSplitTemplateProps {
    element: any
}

const HomeComboSplitTemplate: React.FC<HomeComboSplitTemplateProps> = (element) => {

    const [verticalAlignment, setVerticalAlignment] = useState<string>('');

    useEffect(()=>{
        if(element?.element){
            if(element?.element?.TextVerticalAlignment?.toLowerCase() == 'middle'){
                setVerticalAlignment("align-self-center");
            }
            else if(element?.element?.TextVerticalAlignment?.toLowerCase() == 'top'){
                setVerticalAlignment("align-self-start");
            }
            else {
                setVerticalAlignment("align-self-end");
            }
        }
    },[element?.element])

    const handleContent = (content: any) => {
        return <div className='container-fluid  py-5'>
            <div className='row'>
                <div className={'col-lg-6 hid-overflow '+verticalAlignment+' '+ (content?.ImagePosition?.toLowerCase()== "left" ? "order-3" : "order-lg-1 order-2")}>
                    <div className={content?.ImagePosition?.toLowerCase() == "left" ? "fadeInLeft" : "fadeInRight"}>
                        <style>{`#main .arrowed-link:hover{color: #F37D16 !important}`}</style>
                        <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.FeaturedText}</ReactMarkdown>
                        <div className='clearfix'></div>
                        {content?.Button?.URL ?
                        <a href={content?.Button?.URL} target={content?.Button?.OpenLinkInANewTab ? '_blank' : '_self'} className='default-btn mt-4' id={content?.ButtonID}>{content?.Button?.LinkText}</a>
                        :content?.Html5Video?.data?.attributes?.url ?
                        <a href={content?.Html5Video?.data?.attributes?.url} data-fancybox className='default-btn mt-4' id={content?.ButtonID}>{content?.Html5VideoButtonText}</a>
                        :<></>}
                        {content?.Link?.URL ?
                        <a href={content?.Link?.URL} data-text={content?.Link?.LinkText +' >> '} className='arrowed-link lg_font_size ml-lg-5 ml-4' target={content?.Link?.OpenLinkInANewTab ? '_blank' : '_self'}>
                            {content?.Link?.LinkText}
                            <i className='icon-angle-right'></i>
                        </a>
                        :<></>}
                    </div>
                </div>
                <div className='col-lg-6 hid-overflow mb-lg-0 mb-5 order-lg-2 order-1'>
                    <img src={SOURCE_URL + content?.FeaturedImage?.data?.attributes?.url} className={'img-fluid d-block featured-combo-img img-contain h-100 w-100 '+(content?.ImagePosition?.toLowerCase() == "left" ? "fadeInRight ml-lg-0 mr-auto ml-auto" : "fadeInLeft mr-lg-0 ml-auto mr-auto")}/>
                </div>
            </div> 
        </div>;
    }

    return (
      <>
        {element?.element?.ShowIn == 'Both Desktop and Mobile' ? 
        <section className='featured-section tpl-1 position-relative'>
            {handleContent(element?.element)}
        </section>
        : element?.element?.ShowIn == 'Desktop Only' ?
        <section className='featured-section tpl-1 position-relative d-lg-block d-none'>
            {handleContent(element?.element)}
        </section>
        : element?.element?.ShowIn == 'Mobile Only' ?
        <section className='featured-section tpl-1 position-relative d-lg-none d-block'>
            {handleContent(element?.element)}
        </section>
        :<></>}
      </>
    );
};

export default HomeComboSplitTemplate;